import React from "react";
import { LockIcon, MailIcon, ShieldCheckIcon } from "lucide-react";
import { volumes } from "../data/volumes";
import { bonuses } from "../data/bonuses";
import { guarantee } from "../data/contact";
import { CtaButton } from "./CtaButton";
import { CountrySelector } from "./CountrySelector";
import { CHECKOUT_URL } from "../utils/checkout";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
const OFFER_CTA_LABEL = "Quiero mi colección completa";
export function OfferSection() {
  const checkoutHref = CHECKOUT_URL || "#oferta";
  const {
    mainPrice,
    bonusesTotal
  } = useLocalizedPrices();
  const trust = [{
    icon: LockIcon,
    label: "Pago seguro"
  }, {
    icon: MailIcon,
    label: "Acceso por correo"
  }, {
    icon: ShieldCheckIcon,
    label: `Garantía ${guarantee.days} días`
  }];
  return <section id="oferta" aria-label="Oferta" className="bg-cocoa-950 px-4 pb-12 pt-4 text-cream-100 sm:px-5 sm:py-20" data-id="element-166" data-mp="2t6b3g74mvfgs">
      <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-[28px] bg-cream-50 text-cocoa-900 ring-1 ring-caramel-500/40 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.9)]" data-id="element-167" data-mp="2y4w4g8rpm36a">
        {/* Encabezado de la tarjeta */}
        <header className="bg-cocoa-900 px-5 py-3 text-center" data-id="element-168" data-mp="xuyxahpct4li">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-caramel-300" data-id="element-169" data-mp="sy8idxpacf1o">Colección completa</p>
        </header>

        {/* Contenido */}
        <div className="px-5 pt-5 sm:px-8 sm:pt-6" data-id="element-170" data-mp="1lmwaac4ji2o7">
          <dl className="divide-y divide-cocoa-900/10 text-center" data-id="element-171" data-mp="1lll5c8zcyovi">
            <ContentRow count="6" label="Volúmenes digitales" items={volumes.map(v => v.topic)} data-id="element-172" data-mp="1gococbpy4qvu" />
            <ContentRow count="4" label="Bonos incluidos" items={bonuses.map(b => b.shortTitle)} data-id="element-173" data-mp="1ckn1prsu0jdg" />
          </dl>

          {/* Valor tachado de los bonos */}
          <div className="mb-5 flex items-center justify-center gap-4 rounded-2xl bg-cream-100 px-4 py-3.5 ring-1 ring-caramel-500/30" data-id="element-174" data-mp="16j8inu2iz9g">
            <div className="text-center" data-id="element-175" data-mp="3sbspjq03436x">
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-cocoa-600" data-id="element-176" data-mp="3sewzz5457v61">Valor de los bonos</p>
              <p className="relative mt-1 inline-block font-display text-3xl font-semibold leading-none text-cocoa-600" data-id="element-177" data-mp="2nooc51nczt6">
                <span className="sr-only" data-id="element-178" data-mp="3ku2yru0pirmt">Valor de referencia </span>{bonusesTotal}
                <span className="absolute left-[-6%] top-1/2 h-[3px] w-[112%] -translate-y-1/2 -rotate-[8deg] rounded-full bg-caramel-600" aria-hidden="true" data-id="element-179" data-mp="3oumv4vdghr7w" />
              </p>
            </div>
            <span className="rounded-full bg-caramel-500 px-4 py-2 text-sm font-bold uppercase tracking-wider text-cocoa-950" data-id="element-180" data-mp="3fvt2fg38xkzm">
              Gratis
            </span>
          </div>
        </div>

        {/* Precio + botón */}
        <div className="px-5 pb-6 pt-1 text-center sm:px-8 sm:pb-8" data-id="element-181" data-mp="3622h2k2f1qo5">
          <div className="flex items-center gap-3" aria-hidden="true" data-id="element-182" data-mp="2s55syqdomnay">
            <span className="h-px flex-1 bg-cocoa-900/15" data-id="element-183" data-mp="2x40alozwy5th" />
            <span className="font-display text-sm italic text-cocoa-600" data-id="element-184" data-mp="2x5joxa20e6sm">todo por</span>
            <span className="h-px flex-1 bg-cocoa-900/15" data-id="element-185" data-mp="2dk1e9mfy0ep8" />
          </div>

          <p className="mt-3 text-center font-display text-5xl font-semibold leading-none text-cocoa-900 sm:text-6xl" data-id="element-186" data-mp="28kez37gk0ods">{mainPrice}</p>
          <p className="mt-2 text-center text-sm font-medium text-cocoa-600" data-id="element-187" data-mp="2mgaev4fnpjcy">Pago único · Sin suscripciones</p>

          <div className="mt-5" data-id="element-188" data-mp="2wgt1g6ylvdyk">
            <CtaButton href={checkoutHref} label={OFFER_CTA_LABEL} className="cta-btn--block" data-id="element-189" data-mp="2wfri7f7frl5r" />
          </div>

          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs text-cocoa-600" data-id="element-190" data-mp="2rgx0kgl7g2n8">
            {trust.map(t => {
            const Icon = t.icon;
            return <li key={t.label} className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="3181c16bo95db">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-caramel-600" aria-hidden="true" data-id="element-192" data-mp="3f82fmtjbmqwh" />
                  <span data-id="element-193" data-mp="3a98zsugkant5">{t.label}</span>
                </li>;
          })}
          </ul>

          <CountrySelector data-id="element-194" data-mp="18i8ttigkva2j" />
        </div>
      </div>
    </section>;
}
type ContentRowProps = {
  count: string;
  label: string;
  items: string[];
  note?: React.ReactNode;
};
function ContentRow({
  count,
  label,
  items,
  note
}: ContentRowProps) {
  return <div className="py-4 first:pt-0" data-id="element-195" data-mp="1ma6wbafsa7pq">
      <dt className="flex items-center justify-center gap-2.5" data-id="element-196" data-mp="1m95b4d5204ua">
        <span className="font-display text-4xl font-semibold leading-none text-caramel-500" data-id="element-197" data-mp="pkpho5ytpbbw">{count}</span>
        <span className="text-xs font-bold uppercase tracking-[0.16em] text-cocoa-900" data-id="element-198" data-mp="uir3gynmvor2">{label}</span>
      </dt>
      <dd className="mx-auto mt-2 max-w-sm" data-id="element-199" data-mp="yjt2pfhjw0t1">
        <ul className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-sm leading-relaxed text-cocoa-700" data-id="element-200" data-mp="ymyp2mysool2">
          {items.map(item => <li key={item} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-201" data-mp="2a0sr400s1vhs">
              <span className="h-1 w-1 rounded-full bg-caramel-500" aria-hidden="true" data-id="element-202" data-mp="2eykt5mv4yxzp" />
              {item}
            </li>)}
        </ul>
        {note && <p className="mt-2 flex items-center justify-center text-xs text-cocoa-600" data-id="element-203" data-mp="2p55fn5xwfs7h">{note}</p>}
      </dd>
    </div>;
}